// extracted by mini-css-extract-plugin
export default {"blueArrowIcon":"SelectBlueArrowIcon_blueArrowIcon__ltqLy"};